'use client';

import { showDialog } from '@wwe-portal/ui/components/dialog';
import { YoutubePlayButtonUI } from '@wwe-portal/ui/features/dashboard-revamp/youtube-play-button';
import { YoutubeDialog } from '@wwe-portal/ui/components/dialog/youtube-dialog';

export const YoutubePlayButton = () => {
  const onOpenVideo = () => {
    showDialog(YoutubeDialog, {
      url: 'https://www.youtube.com/embed/2mbX3Za5ihw?si=BYpNbULJQ-6P8N0-&autoplay=1&enablejsapi=1',
      videoId: 'wz-NIG8tto0',
    });
  };

  return (
    <YoutubePlayButtonUI
      onClick={onOpenVideo}
      imageElement={
        <img src="/assets/images/dashboard/banner-play-button.svg" alt="play" />
      }
    />
  );
};
